export const FIND_OPEN_PROCESS_STATEMENTS_REQUEST = 'FIND_OPEN_PROCESS_STATEMENTS_REQUEST';

export const findOpenProcessStatementsRequest = ({
     filter = [],
     sorting = { field: 'title', order: 'ASC' },
     pagination = { page: 1, take: 50 },
 }) => ({
    type: FIND_OPEN_PROCESS_STATEMENTS_REQUEST,
    payload: { filter, sorting, pagination },
    meta: {
        sorting,
        pagination,
    }
});
